// Marco portrait (vertical) compartido por los previews de juego del tab
// Juegos. POR QUE: el dueño quiere ver la pantalla REAL del juego —en
// vertical, con el fondo del kiosko— en una columna sticky a la derecha
// que ocupe todo el alto disponible, igual que el PantallaPreview de
// Ajustes pero GRANDE (no la miniatura w-64). Acá va el chrome común
// (fondo + recorte portrait + altura sticky) y cada juego inyecta su
// contenido como children (la rueda, el mock de raspadita, el tablero).
//
// bgUrl: bg_portrait_url del shopping (global_settings). Solo lo tenemos
// cuando el super_admin cargó los global settings; si falta (admin de
// sucursal o aún cargando) caemos a un fondo neutro oscuro — mismo color
// base que el kiosko real (#0f0c29) para que el preview no se vea roto.
export function GamePreviewFrame({
  bgUrl,
  children,
}: {
  bgUrl: string | null;
  children: React.ReactNode;
}) {
  return (
    // Llena el alto del CONTENEDOR. El riel fijo de la pestaña Juegos lo fija
    // a h-screen (lg:fixed), así el preview queda fijo a todo el alto y no se
    // mueve con el scroll de los controles. En mobile el padre le da un alto
    // acotado. El ancho lo deriva la proporción 9:16; mx-auto/center.
    <div className="flex h-full w-full items-center justify-center">
      {/* El fondo va con cover para imitar la pantalla real (la imagen llena
          el frame). */}
      <div
        className="flex aspect-[9/16] h-full max-h-full max-w-full items-center justify-center overflow-hidden rounded-2xl border border-white/15 shadow-2xl"
        style={{
          backgroundColor: "#0f0c29",
          backgroundImage: bgUrl ? `url(${bgUrl})` : undefined,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {children}
      </div>
    </div>
  );
}
